import { render, staticRenderFns } from "./VitalsSurveyNotAuthorized.vue?vue&type=template&id=1ebf7d9c&scoped=true&"
import script from "./VitalsSurveyNotAuthorized.vue?vue&type=script&lang=js&"
export * from "./VitalsSurveyNotAuthorized.vue?vue&type=script&lang=js&"
import style0 from "./VitalsSurveyNotAuthorized.vue?vue&type=style&index=0&id=1ebf7d9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebf7d9c",
  null
  
)

export default component.exports